var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "18px",
    viewBox: "0 0 20 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ED12D023-A6CE-40F3-B8B7-CCACF20F058D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 18 19.9480519 18 19.9480519 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "My-Profile---Personal-Info",
    transform: "translate(-912.000000, -311.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "camera",
    transform: "translate(912.000000, 311.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.97402597,13.3246753 C8.14796104,13.3246753 6.66233766,11.8390519 6.66233766,10.012987 C6.66233766,8.18692208 8.14796104,6.7012987 9.97402597,6.7012987 C11.8000909,6.7012987 13.2857143,8.18692208 13.2857143,10.012987 C13.2857143,11.8390519 11.8000909,13.3246753 9.97402597,13.3246753 M9.97402597,5.14285714 C7.28863636,5.14285714 5.1038961,7.3275974 5.1038961,10.012987 C5.1038961,12.6983766 7.28863636,14.8831169 9.97402597,14.8831169 C12.6594156,14.8831169 14.8441558,12.6983766 14.8441558,10.012987 C14.8441558,7.3275974 12.6594156,5.14285714 9.97402597,5.14285714",
    id: "Fill-1",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3896104,15.6622987 C18.3896104,16.091961 18.0400519,16.4415195 17.6103896,16.4415195 L2.33766234,16.4415195 C1.908,16.4415195 1.55844156,16.091961 1.55844156,15.6622987 L1.55844156,5.14285714 C1.55844156,4.71319481 1.908,4.36363636 2.33766234,4.36363636 L5.25974026,4.36363636 C5.94623377,4.36363636 6.56345455,3.98220779 6.87046753,3.36818182 C6.87276623,3.36366234 6.87494805,3.3591039 6.87716883,3.35454545 L7.67025974,1.68798701 C7.7122987,1.60796104 7.79403896,1.55844156 7.88477922,1.55844156 L12.1187922,1.55844156 C12.2095325,1.55844156 12.2912727,1.60796104 12.3333117,1.68794805 L13.1264026,3.35450649 C13.1286234,3.35906494 13.1308052,3.36362338 13.1331039,3.36814286 C13.4401169,3.98216883 14.0573377,4.3635974 14.7438312,4.3635974 L17.6103896,4.3635974 C18.0400519,4.3635974 18.3896104,4.71315584 18.3896104,5.14281818 L18.3896104,15.6622987 Z M17.6103896,2.80519481 L14.7438312,2.80519481 C14.6530909,2.80519481 14.5713117,2.75567532 14.5292338,2.67557143 L13.7361818,1.00909091 C13.734,1.00453247 13.7318182,1.00001299 13.7295195,0.995493506 C13.4225455,0.381467532 12.8053247,0 12.1187922,0 L7.88477922,0 C7.19824675,0 6.58102597,0.381467532 6.27405195,0.995532468 C6.27175325,1.00005195 6.26957143,1.00457143 6.26738961,1.00912987 L5.4742987,2.67568831 C5.43222078,2.75567532 5.35048052,2.80519481 5.25974026,2.80519481 L2.33766234,2.80519481 C1.04867532,2.80519481 0,3.85387013 0,5.14285714 L0,15.6623377 C0,16.9513247 1.04867532,18 2.33766234,18 L17.6103896,18 C18.8993766,18 19.9480519,16.9513247 19.9480519,15.6623377 L19.9480519,5.14285714 C19.9480519,3.85387013 18.8993766,2.80519481 17.6103896,2.80519481 L17.6103896,2.80519481 Z",
    id: "Fill-3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "15.2727273 7.48051948 16.8311688 7.48051948 16.8311688 5.92207792 15.2727273 5.92207792"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.44acbbc8.svg";
export { ForwardRef as ReactComponent };